import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(2, 5)
    },
    field: {
        marginBottom: theme.spacing(2)
    },
    groupTitle: {
        color: '#868aa8',
        fontWeight: 'bold'
    },
    filterBtn: {
        height: 38,
        marginLeft: theme.spacing(1),
        padding: theme.spacing(0.5, 1.5)
    },
    icon: {
        fill: 'inherit !important'
    },
    rightdom: {
        marginLeft: 'auto'
    },
    table: {
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5)
    },
    appbar: {
        boxShadow: 'none',
        padding: theme.spacing(0, 5),
        backgroundColor: theme.palette.background.default,
        position: 'relative'
    },
    tabsContainer: {
        color: theme.palette.app.primary
    },
    tabContainer: {
        maxWidth: 'unset'
    },
    tabContent: {
        minHeight: '70vh',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2, 5)
    },
    searchBar: {
        margin: theme.spacing(3, 0)
    },
    fixedTable: {
        maxHeight: "calc(100vh - 295px)",
        overflowY: "auto",
        position: "relative",
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5)
    },
    saveBtn: {
        position: 'absolute',
        right: 55,
        top: 30
    },
    label: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(0.5),
        color: '#061024',
        fontWeight: '600'
    },
    submitBtn: {
        paddingTop: 12,
        paddingBottom: 12
    },
    gridCell: {
        paddingTop: `0px !important`,
        paddingBottom: `0px !important`,
    },
    divider: {
        backgroundColor: 'rgba(0,0,0,0.15)',
        margin: theme.spacing(2, 0)
    },
    excel: {
        marginRight: 20,
        backgroundColor: '#040f40',
        padding: 10,
        color: '#fff',
        borderRadius: 15,
        '&:hover': {
            backgroundColor: '#00B0EC',
        },
    },
}));
export default useStyles;